import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal } from 'shared/actions/modal.action';

import SectionTitle from 'mobile/components/SectionTitle';
import TitleUnderText from 'mobile/components/TitleUnderText';

@connect(
  state => {
    return {
      modal: state.shared.modal,
      start: state.shared.modal.data.start,
    };
  },
  { initModal },
)
class ChallengeStartContainer extends Component {
  render() {
    const { modal = {} } = this.props;
    const { data = {} } = modal;
    const { onClick } = data;

    const style = {
      width: '294px',
      padding: '30px',
      borderRadius: '5px',
      backgroundColor: '#fff',
    };

    const startBtn = {
      padding: '6px 0',
      width: '100px',
      backgroundColor: '#312a75',
      borderRadius: '18.6px',
      color: '#fff',
      textAlign: 'center',
      marginRight: '10px',
    };

    const cancleBtn = {
      padding: '6px 0',
      width: '100px',
      backgroundColor: '#fff',
      border: '1px solid #999',
      borderRadius: '18.6px',
      color: '#999',
      textAlign: 'center',
      marginRight: '10px',
    };
    // console.log('here start', { start });
    return (
      <Dim onClick={this.props.initModal}>
        <div style={style}>
          <SectionTitle
            title={`페이백 챌린지 참가 신청`}
            fontSize={'15px'}
            textAlign={'center'}
            color={'#555'}
          />
          <TitleUnderText
            text={`페이지 챌린지에 도전 하시겠습니까?
            챌린지 도전 이후에는 미션 연장 및 중도 
            멈춤이 불가능 합니다.`}
            fontSize={'14px'}
            color={'#555'}
          />
          <div style={{ margin: '20px auto 0 auto', textAlign: 'center' }}>
            <button
              style={startBtn}
              onClick={() => {
                onClick();
                this.props.initModal();
              }}
            >
              확인
            </button>
            <button style={cancleBtn} onClick={this.props.initModal}>
              취소
            </button>
          </div>
        </div>
      </Dim>
    );
  }
}

export default ChallengeStartContainer;
